// extracted by mini-css-extract-plugin
export default {"fixedButtons":"FixedButtons_fixedButtons__pPefH","button":"FixedButtons_button__6l-y3","chatbotContainer":"FixedButtons_chatbotContainer__LMbuO"};